import {ReactNode} from 'react'
import {StyledAdminHostApprovalTaskImages} from 'src/features/admin-host-approval/components/admin-host-approval-task-images/style'

export const AdminHostApprovalTaskImages = ({children}: {children: ReactNode}) => (
    <StyledAdminHostApprovalTaskImages>{children}</StyledAdminHostApprovalTaskImages>
)
